module.exports = __webpack_public_path__ + "fonts/Cabin-700-vietnamese10.9c5df79.woff2";